import { Mail, Phone, SquarePen } from 'lucide-react'

import { BrokerActionButton } from '@/components/ui/BrokerActionButton'
import { BrokerContactActions } from '@/components/ui/BrokerContactActions'
import { CopyButton } from '@/components/ui/CopyButton'
import { Demo, DsSection } from '../primitives'

const BROKER = { name: 'Lupita Escamilla', phone: '(770) 615-0798', email: 'lupita@cai.ai' }

function VariantName({ value }: { value: string }) {
  return (
    <div className="text-ink-400 flex items-center gap-1 font-mono text-[10px]">
      {value}
      <CopyButton
        value={value}
        className="text-ink-400 hover:text-ink size-4 bg-transparent hover:bg-transparent"
      />
    </div>
  )
}

export function BrokerActionsSection() {
  return (
    <DsSection id="broker-actions" title="Broker actions">
      <Demo label="BrokerActionButton" className="flex flex-wrap items-start gap-8">
        <div className="flex flex-col items-start gap-2">
          <BrokerActionButton aria-label="Email Lupita">
            <Mail />
          </BrokerActionButton>
          <VariantName value="<BrokerActionButton>" />
        </div>
        <div className="flex flex-col items-start gap-2">
          <BrokerActionButton size="sm">
            <Phone />
            {BROKER.phone}
          </BrokerActionButton>
          <VariantName value='size="sm"' />
        </div>
        <div className="flex flex-col items-start gap-2">
          <BrokerActionButton aria-label="Leave Lupita a note">
            <SquarePen />
          </BrokerActionButton>
          <VariantName value="<BrokerActionButton>" />
        </div>
      </Demo>

      <Demo label="BrokerContactActions" className="flex flex-wrap items-start gap-8">
        <div className="flex flex-col items-start gap-2">
          <BrokerContactActions {...BROKER} />
          <VariantName value="<BrokerContactActions />" />
        </div>
        <div className="flex flex-col items-start gap-2">
          <BrokerContactActions {...BROKER} hidePhoneNumber />
          <VariantName value="hidePhoneNumber" />
        </div>
      </Demo>
    </DsSection>
  )
}
